import React from "react"
import { ChevronsRight } from "lucide-mui"
import ActivityBase from "@/components/activities/base"
import OwnerLabel from "@/components/activities/owner_label"
import i18n from "@/i18n"

interface PlansUpdatedProps {
  activity: any
  className?: string
}

const PlansUpdated = ({ activity, className }: PlansUpdatedProps) => {
  const renderPlanChanges = () => {
    const changes = activity.parameters?.changes
    if (!changes) return null

    const { created, updated, deleted } = changes

    const hasChanges =
      (created && created.length > 0) || (updated && updated.length > 0) || (deleted && deleted.length > 0)

    if (!hasChanges) return null

    return (
      <div className="mt-2 space-y-3">
        {created && created.length > 0 && (
          <div>
            <div className="text-sm mb-2">
              <span className="font-semibold text-green-600">{i18n.t("app.activities.venue.plans.added")}:</span>
            </div>
            <div className="flex flex-col gap-2 ml-4">
              {created.map((item, index) => (
                <span key={`created-${index}`} className="text-sm text-gray-700">
                  {item.section_name}
                </span>
              ))}
            </div>
          </div>
        )}

        {updated && updated.length > 0 && (
          <div>
            <div className="text-sm mb-2">
              <span className="font-semibold text-blue-600">{i18n.t("app.activities.venue.plans.updated")}:</span>
            </div>
            <div className="flex flex-col gap-2 ml-4">
              {updated.map((item, index) => (
                <div key={`updated-${index}`} className="flex flex-row items-center gap-2 flex-wrap">
                  <span className="text-sm text-gray-700">{item.from.section_name}</span>
                  <ChevronsRight className="text-sm text-gray-400 w-4 h-4" />
                  <span className="text-sm text-gray-700">{item.to.section_name}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {deleted && deleted.length > 0 && (
          <div>
            <div className="text-sm mb-2">
              <span className="font-semibold text-red-600">{i18n.t("app.activities.venue.plans.removed")}:</span>
            </div>
            <div className="flex flex-col gap-2 ml-4">
              {deleted.map((item, index) => (
                <span key={`deleted-${index}`} className="text-sm text-gray-700">
                  {item.section_name}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    )
  }

  return (
    <ActivityBase
      data-testid="panel-activity-venue-plans-updated"
      activityKey={activity.key}
      text={
        <>
          {i18n.react("app.activities.venue.plans_updated.description", {
            owner: <OwnerLabel owner={activity.owner} />,
          })}
          {renderPlanChanges()}
        </>
      }
      createdAt={activity.createdAt}
      className={className}
    />
  )
}

export default PlansUpdated
